import { render, staticRenderFns } from "./GalleriesSection.vue?vue&type=template&id=090850c5&scoped=true&"
import script from "./GalleriesSection.vue?vue&type=script&lang=js&"
export * from "./GalleriesSection.vue?vue&type=script&lang=js&"
import style0 from "./GalleriesSection.vue?vue&type=style&index=0&id=090850c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090850c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VRow})
